import { render, staticRenderFns } from "./WeChatTrain.vue?vue&type=template&id=df1cc202&scoped=true&"
import script from "./WeChatTrain.vue?vue&type=script&lang=js&"
export * from "./WeChatTrain.vue?vue&type=script&lang=js&"
import style0 from "./WeChatTrain.vue?vue&type=style&index=0&id=df1cc202&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df1cc202",
  null
  
)

export default component.exports